import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Popup from '../Popup';
import Button from '../Button';
import Logo from '../Logo';
import s from './VerificationPopup.scss';
export var VerificationPopup = function (_a) {
    var email = _a.email, actionType = _a.actionType, changeEmail = _a.changeEmail, resendEmail = _a.resendEmail, onClose = _a.onClose;
    var t = useTranslation().t;
    return (React.createElement(Popup, { onRequestClose: onClose, isOpen: true, overlayClassName: s['modal-overlay'], className: s['modal'] },
        React.createElement("div", { className: s['root'] },
            React.createElement("div", { className: s['left'] },
                React.createElement("div", { className: s['overlay'] }),
                React.createElement(Logo, { className: s['logo'], markColor: "white", textColor: "white" }),
                React.createElement("div", { className: s['almost'] }, t('verification.almost'))),
            React.createElement("div", { className: s['right'] },
                React.createElement("div", { className: s['title'] }, t('verification.needVerification', {
                    action: t("verification.action." + actionType),
                })),
                React.createElement("div", { className: s['text'] },
                    React.createElement(Trans, { i18nKey: "verification.checkEmail" },
                        "Just click the link in the email we sent to",
                        ' ',
                        React.createElement("span", { className: s['email'] }, { email: email }))),
                React.createElement("div", { className: s['buttons'] },
                    React.createElement(Button, { view: "b3", height: "medium", className: s['button'], onClick: function () {
                            resendEmail();
                            onClose();
                        } }, t('verification.resend')),
                    React.createElement("div", { className: s['or-line'] },
                        React.createElement("span", { className: s['or-bar'] }),
                        React.createElement("span", { className: s['or'] }, t('verification.or')),
                        React.createElement("span", { className: s['or-bar'] })),
                    React.createElement(Button, { view: "b3", height: "medium", className: s['button'], onClick: function () {
                            changeEmail();
                            onClose();
                        } }, t('verification.changeMail'))),
                React.createElement(Button, { view: "b1-1", className: s['got-it'], onClick: onClose }, t('verification.gotIt'))))));
};
VerificationPopup.displayName = 'VerificationPopup';
export default VerificationPopup;
//# sourceMappingURL=VerificationPopup.js.map